import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from './SectionHeading';
import { afterItems, beforeItems, TransformationItem } from '../../data/transformation';
function Column({
  variant,
  title,
  items
}: {
  variant: 'before' | 'after';
  title: string;
  items: TransformationItem[];
}) {
  const isBefore = variant === 'before';
  return <div className={`rounded-3xl border p-4 sm:p-6 ${isBefore ? 'border-slate-200 bg-white' : 'border-navy-800 bg-navy-900'}`} data-id="element-228" data-mp="1isr5vzv3j1bh">
      <p className={`mb-5 text-center text-[11px] font-extrabold uppercase tracking-[0.18em] ${isBefore ? 'text-rose-500' : 'text-gold-400'}`} data-id="element-229" data-mp="2bgd6cz911pu4">
        {title}
      </p>
      <ul className="space-y-3" data-id="element-230" data-mp="21oh89o6xxzpw">
        {items.map(item => <li key={item.title} className={`flex gap-3 rounded-2xl p-3.5 ${isBefore ? 'bg-slate-50' : 'bg-navy-800/70'}`} data-id="element-231" data-mp="2z567rb8f4pw4">
            <span aria-hidden="true" className="mt-0.5 text-xl leading-none" data-id="element-232" data-mp="158g6lv16wakx">
              {item.icon}
            </span>
            <div data-id="element-233" data-mp="1a7j0qkfmswe4">
              <h3 className={`text-[14px] font-bold leading-snug ${isBefore ? 'text-navy-950' : 'text-white'}`} data-id="element-234" data-mp="1a5y7cy51zjhu">
                {item.title}
              </h3>
              <p className={`mt-1 text-[13px] leading-relaxed ${isBefore ? 'text-slate-600' : 'text-white/65'}`} data-id="element-235" data-mp="10fd7l7dn88xc">
                {item.text}
              </p>
            </div>
          </li>)}
      </ul>
    </div>;
}
export function Transformation() {
  return <section className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-236" data-mp="hi2btwr7zxmn">
      <div className="mx-auto w-full max-w-5xl" data-id="element-237" data-mp="hkf0stveb897">
        <SectionHeading eyebrow="The Transformation" title={<>
              From Diagnostic Uncertainty to <span className="italic" data-id="element-239" data-mp="2buipvjq9cg22">Clinical Clarity</span>
            </>} intro={<>
              <p data-id="element-240" data-mp="3fugr1woaqwmd">
                Every dental case comes with a long list of information to analyze: medical history,
                clinical examination, photographs, radiographs, occlusion, existing restorations,
                periodontal findings and patient complaints.
              </p>
              <p className="font-semibold text-navy-900" data-id="element-241" data-mp="7enjw8fuuxhz">
                The challenge isn’t having access to the information. It’s knowing what to look at
                first, what matters most, and what to do with what you find.
              </p>
            </>} data-id="element-238" data-mp="27w2sclwjvpae" />

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-242" data-mp="3upmz0p6yd5ic">
          <Column variant="before" title="Before" items={beforeItems} data-id="element-243" data-mp="3prlb9qyl0i0j" />
          <Column variant="after" title="With the Clinical Master System™" items={afterItems} data-id="element-244" data-mp="r3640bm07kpt" />
        </div>

        <p className="mx-auto mt-9 max-w-2xl text-center font-display text-lg italic leading-snug text-navy-900 sm:text-xl" data-id="element-245" data-mp="mbo0pgwid81o">
          You don’t need to memorize everything. You need a system that tells you what to evaluate,
          what to prioritize and what to do next.
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-246" data-mp="13kqnmgopvvxm">
          <CTAButton label="I want this clinical system" subline="Instant access · One-time payment · 7-day guarantee" data-id="element-247" data-mp="13jypay3qjk3n" />
        </div>
      </div>
    </section>;
}